initMarquee(".Index_object_testimonials_marquee", {
    mobile: {
        duration: 8e4,
        gap: 0,
        duplicated: !0,
        direction: "left",
        pauseOnHover: !0
    },
    desktop: {
        duration: 8e4,
        gap: 0,
        duplicated: !0,
        direction: "left",
        pauseOnHover: !0
    }
});
const playlist = document.querySelector(".video_play_list");
document.querySelectorAll(".mute_video").forEach(function(e) {
    e.addEventListener("click", function() {
        e.classList.remove("active");
        const t = e.closest(".full_video_new");
        t.querySelector(".unmute_video").classList.add("active"),
        t.querySelector("video").muted = !0
    })
}),
document.querySelectorAll(".unmute_video").forEach(function(e) {
    e.addEventListener("click", function() {
        e.classList.remove("active");
        const t = e.closest(".full_video_new")
          , o = t.querySelector("video");
        playlist.querySelectorAll("video").forEach(function(l) {
            l.muted = !0
        }),
        playlist.querySelectorAll(".full_video_new").forEach(function(l) {
            l.querySelector(".mute_video").classList.remove("active"),
            l.querySelector(".unmute_video").classList.add("active")
        }),
        t.querySelector(".unmute_video").classList.remove("active"),
        t.querySelector(".mute_video").classList.add("active"),
        o.muted = !1
    })
}),
document.addEventListener("DOMContentLoaded", () => {
    const e = document.querySelector(".Index_object_testimonials_marquee");
    if (!e)
        return;
    const t = document.createElement("div");
    t.className = "custom-scrollbar";
    const o = document.createElement("div");
    o.className = "custom-scrollbar-thumb",
    t.appendChild(o),
    e.insertAdjacentElement("afterend", t);
    const l = () => {
        const c = e.clientWidth / e.scrollWidth;
        o.style.width = Math.max(c * t.clientWidth, 30) + "px";
        const n = e.scrollWidth - e.clientWidth
          , i = t.clientWidth - o.offsetWidth
          , s = n ? e.scrollLeft / n : 0;
        o.style.transform = `translateX(${s * i}px)`
    }
    ;
    e.addEventListener("scroll", l),
    window.addEventListener("resize", l),
    l();
    let r = !1, d, a;
    o.addEventListener("mousedown", c => {
        c.stopPropagation(),
        r = !0,
        d = c.pageX,
        a = e.scrollLeft,
        document.body.classList.add("no-select")
    }
    ),
    document.addEventListener("mousemove", c => {
        if (!r)
            return;
        const n = c.pageX - d
          , i = e.scrollWidth - e.clientWidth
          , s = t.clientWidth - o.offsetWidth;
        e.scrollLeft = a + n / s * i
    }
    ),
    document.addEventListener("mouseup", () => {
        r = !1,
        document.body.classList.remove("no-select")
    }
    ),
    t.addEventListener("click", c => {
        if (c.target === o)
            return;
        const n = t.getBoundingClientRect()
          , i = c.clientX - n.left
          , s = t.clientWidth - o.offsetWidth
          , u = e.scrollWidth - e.clientWidth
          , m = i - o.offsetWidth / 2
          , v = Math.min(Math.max(m / s, 0), 1);
        e.scrollLeft = v * u
    }
    )
}
);